import { useAuthAppStore } from "@/store/stores/authStore";

export class ReportService {
  async getReportFile({ reportServiceClient, route, params }) {
    var response = await reportServiceClient.get({
      // route: "/purchase-request/get-report-file",
      route: route,
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }
}
